export const messages = {
    nb: {
        toastFailed: `Henting av CMS Arikkel feilet!`,
        toastOk: `CMS artikkel hentet ok`,
    }
}

